//*******************************************************
import { Component, ViewChild } from '@angular/core';
//*******************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';

import { Observable, Subscription }       from 'rxjs';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";
//*******************************************************
// Devexpress 
import { DxTileViewComponent }                from 'devextreme-angular';
//*******************************************************
// Field Definitions
import  { 
          inviteefield,
          whoseguestinit,
          listinvitation  
        }                                 from '../../appfirestore/app.fields';
//*******************************************************     
// Functions
import { appfunctions  }                  from '../../functions/app.functions';
//******************************************************* 

// JQuery 
import 'devextreme/integration/jquery';
//*******************************************************

// TODO -> A popup when clicking the tileView will list all delivery options a. Street address b. Postal address or c. Email address from listed invitee. You will than decide which opotion to choose. 

@Component(
            {
              selector: 'app-cominviteeinvite',
              templateUrl: './cominviteeinvite.component.html',
              styleUrls: ['./cominviteeinvite.component.scss']
            }
          )
//*******************************************************
export class CominviteeinviteComponent 
{
    @ViewChild('invitetile') inviteTile: DxTileViewComponent;
    //*******************************************************
    eventid: string = '';
    formheight: number = 0;
    //---------------------------------------------------------------------------------------------
    // Firestore Paths
    pathinvitee: string = "/eventinvitee/inviteelist";
    pathinvitationlist: string = "/eventinvitationlist/invitationlist";

    // eventinvitee
    subscriptioninvitee: Subscription;
    subscriptioninviteelist: inviteefield[];

    // eventinvitationlist
    subscriptioninvitation: Subscription;
    subscriptioninvitationlist: listinvitation[];
    //---------------------------------------------------------------------------------------------
    whoseguest: Array<whoseguestinit> = []; // Empty Array
    invitedeliverylist: string[];
    listinvitationid: string;

    dragitem: string;
    dragitem_inviteeid: string;
    dragitem_inviteename: string;
    dragitem_invitationlistid: string;
    dragfromcomponent: string;
    dragtocomponent: string;
    dragitemindex: number;

    selcurrentdelivery: string;

    deliveryhint: string = '';

    popupVisible: boolean = false;
    positionOf: string;
    //*******************************************************
    constructor (
                  private routernavigate: Router,
                  private _Activatedroute:ActivatedRoute,
                  private firestoredata: firestorecontrol, 
                  private appfunction: appfunctions
                ) 
      { 
        //---------------------------------------------------------------------------------------------
        // Binding Objects
        this.onDragStartInviteeName = this.onDragStartInviteeName.bind(this);

        this.onDragStart = this.onDragStart.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);

        this.onAdd = this.onAdd.bind(this);
        this.onRemove = this.onRemove.bind(this);
        //---------------------------------------------------------------------------------------------
      }
    //*******************************************************
    ngOnInit(): void 
      {
        //---------------------------------------------------------------------------------------------
        // EventId
        this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
        //---------------------------------------------------------------------------------------------
        // Establish Connection to event -> eventparticipant
        this.firestoredata.loadeventinvitee_nolist( this.eventid );

        this.subscriptioninvitee = this.firestoredata.geteventinvitee_nolist().subscribe
          ( items => 
            { 
              this.subscriptioninviteelist = items;
             // console.log( this.subscriptioninviteelist )
            }
          )
        //---------------------------------------------------------------------------------------------
        // Establish Connection to event -> eventinvitationlist
        this.firestoredata.loadinvitationcard( this.eventid );

        this.subscriptioninvitation = this.firestoredata.geteventinvitationlist().subscribe
          ( items => 
            { 
              this.subscriptioninvitationlist = items;
              //console.log( this.subscriptioninvitationlist )
            }
          )
        //---------------------------------------------------------------------------------------------
        // Event Organiser Initials
        this.firestoredata.buildwhoseguestdetails( this.eventid );
        this.whoseguest = this.firestoredata.geteventparticipantdetails();
        //---------------------------------------------------------------------------------------------
      }
    //*******************************************************
    ngOnDestroy() 
      {
        this.subscriptioninvitee.unsubscribe(); 
        this.subscriptioninvitation.unsubscribe();
         
      }
    //*******************************************************  
    rowcellclick( event: any )
      {

        //  console.log( event )

        //  console.log( event.eventType) // 'dxClick'
        //  console.log( event.row.rowType) // 'data

       //   console.log( event.columnIndex) // 'column

      }
  //*******************************************************
  // Dragging Invitee Details frpm DataGrid
  onDragStartInviteeName(e) 
      {
        // DxDatagrid -> DxList
        // Invitee Id
        this.dragitem_inviteeid = e.itemData.id;
        this.dragitem           = e.itemData.firstname + ' ' + e.itemData.lastname + ' - [' +  e.itemData.id + ']' ;

      //  console.log (  this.dragitem_inviteeid  + ' ' + this.dragitem )
      }
  //*******************************************************
  // Tile Click
  // TODO - build delivery options by clicking on TileView
  tileselect( event: any)
    {
      //console.log( event.itemData.id )
      //console.log( event.itemData.inviteename )
     // this.build_invitee_deliveryoptions( event.itemData.id, event.itemData.inviteename )

    }

  build_invitee_deliveryoptions( invitelinkid: string, inviteelist: [])
    {
      
      this.listinvitationid = invitelinkid;

      if ( inviteelist.length > 0 ) 
        {
          
          this.invitedeliverylist = [];
          this.firestoredata.buildinviteedeliveryinvite( this.eventid, 'invitelinkid', invitelinkid ).then( ( inviteedelivery ) => 
                                                                                                  { 
                                                                                                    //  console.log( inviteedelivery ); 
                                                                                                    this.positionOf =  `#tileview${invitelinkid}`;
                                                                                                    this.invitedeliverylist = inviteedelivery

                                                                                                    this.popupVisible = false;
                                                                                                    if ( this.invitedeliverylist.length > 0 )
                                                                                                      {
                                                                                                        this.popupVisible = true;
                                                                                                      }
                                                                                                    
                                                                                                  }
                                                                                            );
        }

    }
  //*******************************************************      
  // Adding Invitee Name to Invitation List
  onAdd(e) 
    {
     
      // console.log( e )
      // Component whhere Item is being Drag from
      this.dragfromcomponent = e.fromComponent.NAME;
      this.dragtocomponent   = e.toComponent.NAME;

     // console.log(  'From:' + this.dragfromcomponent + ' ' + 'To:' + this.dragtocomponent )
      //---------------------------------------------------------------------------------------------
      // From: dxdatagrid to dxlist
      if ( ( this.dragfromcomponent.toUpperCase()  == 'DXDATAGRID') && ( this.dragtocomponent.toUpperCase()  == 'DXLIST') )
        {
          // Destination InviteGroup - invitationid
          this.dragitem_invitationlistid = this.extract_invitationid( 10, e.toData[0], ':' );

          // Add Invitee to Invitation List
          e.toData.splice(e.toData.length,  0,  this.dragitem );

          // Update Firestore -> eventinvitee->inviteelist->invitee->invitelinkid to indicate that invitee is registered on a invitation list
          this.firestoredata.commitbatchupdate( 
                                                  this.pathinvitee, 
                                                  this.eventid,
                                                  this.dragitem_inviteeid,
                                                  'invitelinkid', 
                                                  this.dragitem_invitationlistid
                                              );

          this.firestoredata.commitbatchupdate( 
                                                this.pathinvitee, 
                                                this.eventid,
                                                this.dragitem_inviteeid,
                                                'invitelinkstatus', 
                                                "1"
                                               );

          // Update Firestore -> eventinvitationlist->invitationlist->doc->inviteename to list of invitees to the invitation list
          this.firestoredata.commitbatchupdate( 
                                                  this.pathinvitationlist, 
                                                  this.eventid,
                                                  this.dragitem_invitationlistid,
                                                  'inviteename', 
                                                  e.toData
                                              );

        
        }
      //---------------------------------------------------------------------------------------------
      // From: dxlist to dxlist
      if ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXLIST') )
        {
        
          // Top Node of Dxlist cannot be drag & drop
          if ( this.dragitemindex != 0 )
            {
              // Destination dxlist
              this.dragitem_invitationlistid = this.extract_invitationid( 10, e.toData[0], ':' );
              this.dragitem_inviteeid = this.extract_invitationid( 20, this.dragitem, '[' );
          
              // Add Invitee to DxList
              e.toData.splice(e.toData.length,  0,  this.dragitem );

              // Firstore - Update Invitee - Invitelinkid
              this.firestoredata.commitbatchupdate( 
                                                      this.pathinvitee, 
                                                      this.eventid,
                                                      this.dragitem_inviteeid,
                                                      'invitelinkid', 
                                                      this.dragitem_invitationlistid
                                                  );

              // Firstore - Update DxList
              this.firestoredata.commitbatchupdate( 
                                                      this.pathinvitationlist, 
                                                      this.eventid,
                                                      this.dragitem_invitationlistid,
                                                      'inviteename', 
                                                      e.toData
                                                  );
            }
          else
            {
              console.log( 'Cannot drop')
            }
        }

      //---------------------------------------------------------------------------------------------
        //From: dxlist to dxdatagrid
      // if ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXDATAGRID') )
      //   {
            // Need to Test
            // Update Firestore with status
        //    this.dragitem_inviteeid = this.extract_invitationid( 20, this.dragitem, '[' );
        //    this.dragitem_invitationlistid = this.extract_invitationid( 10, e.fromData[0], ':' );

            // Update Firestore -> inviteelist->invitee->invitelinkid to indicate that invitee is deregistered on a invitation list
        //   this.firestoredata.commitbatchupdate( 
        //                                           this.pathinvitee, 
        //                                           this.eventid,
        //                                           this.dragitem_inviteeid,
        //                                           'invitelinkid', 
        //                                           '0'
        //                                       );
        //---------------------------------------------------------------------------------------------
        //}
      
    }
  //*******************************************************
  onDragStart(e) 
    {

      e.itemData = e.fromData[e.fromIndex];

      this.dragitemindex = e.fromIndex   // Prevent dragitemindex = 0 from being dragged.

      if ( e.fromIndex == 0 )
        {
          e.cancel = true;
        }
      else
        {
          this.dragitem               = e.itemData 
          this.dragitem_inviteename   = this.extract_invitationid( 30, e.itemData, '-' )
        }
    }

  onDragEnd(e) 
    {
      if ( e.toIndex  === 0 )
        {
         // e.cancel = true;
        }
      
    }
  //*******************************************************
  onRemove(e) 
    {

      this.dragfromcomponent = e.fromComponent.NAME;
      this.dragtocomponent   = e.toComponent.NAME;
      
      //if ( 
      //      ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXLIST') ) || 
       //     ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXDATAGRID') )
       //   )

      if ( this.dragfromcomponent.toUpperCase()  == 'DXLIST' &&  this.dragtocomponent.toUpperCase()  == 'DXLIST')  
        {
          //console.log( 'ListIndex:' + this.dragitemindex )
          if ( this.dragitemindex != 0 )
            {
              // console.log( 'Remove:' + this.dragitemindex )
              // Source/from - Remove invitee from Dxlist
              e.fromData.splice( this.dragitemindex, 1 );

              // Update Firestore -> eventinvitationlist->invitationlist->doc->inviteename to deregister invitee from to the invitation list
              this.dragitem_invitationlistid = this.extract_invitationid( 10, e.fromData[0], ':' );
              
              this.firestoredata.commitbatchupdate( 
                                                      this.pathinvitationlist, 
                                                      this.eventid,
                                                      this.dragitem_invitationlistid,
                                                      'inviteename', 
                                                      e.fromData
                                                  );

            }
        
        }

    }
  //*******************************************************  
  inviteeonItemDeleted( event: any, invitelist: any )
    {
      //console.log( event )
      // console.log( event.itemData )
      this.dragitem_invitationlistid = this.extract_invitationid( 10,  invitelist[0], ':' );
      this.dragitem_inviteeid = this.extract_invitationid( 20, event.itemData, '[' );

     // console.log( this.dragitem_invitationlistid )
     // console.log( this.dragitem_inviteeid )

      // Update Firestore -> eventinvitee->inviteelist->invitee->invitelinkid to indicate that invitee is deregistered on a invitation list
      this.firestoredata.commitbatchupdate( 
                                            this.pathinvitee, 
                                            this.eventid,
                                            this.dragitem_inviteeid,
                                            'invitelinkid', 
                                            '0'
                                          );

      this.firestoredata.commitbatchupdate( 
                                              this.pathinvitee, 
                                              this.eventid,
                                              this.dragitem_inviteeid,
                                              'invitelinkstatus', 
                                              '0'
                                           );

      // Update Firestore -> eventinvitationlist->invitationlist->doc->inviteename to list of invitees to the invitation list
      this.firestoredata.commitbatchupdate( 
                                              this.pathinvitationlist, 
                                              this.eventid,
                                              this.dragitem_invitationlistid,
                                              'inviteename', 
                                              invitelist   // Array of InviteeName
                                          ).then
                                            ( () => 
                                          
                                              {

                                                if ( invitelist.length == 1 )
                                                  {
                                                        this.firestoredata.commitbatchupdate( 
                                                                                              this.pathinvitationlist, 
                                                                                              this.eventid,
                                                                                              this.dragitem_invitationlistid,
                                                                                              'delivery', 
                                                                                              'TBC'
                                                                                            );

                                                  }
                                                else
                                                  {

                                                    this.firestoredata.invitationdelivery( this.eventid,this.dragitem_invitationlistid ).subscribe
                                                    ( (r) => 
                                                      {
                                                                                                                                                              
                                                        this.selcurrentdelivery = r;  
                                                        // Rebuild Pop Up Delivery List
                                                        this.invitedeliverylist = [];
                                                        this.firestoredata.buildinviteedeliveryinvite( this.eventid,'invitelinkid', this.dragitem_invitationlistid )
                                                          .then( ( inviteedelivery ) => 
                                                                    { 

                                                                      console.log( 'D:' + this.selcurrentdelivery )    

                                                                      this.invitedeliverylist = inviteedelivery

                                                                      if ( this.invitedeliverylist.indexOf( this.selcurrentdelivery ) == -1 )
                                                                        {
                                                                          console.log( 'Not on List')
                                                                          this.firestoredata.commitbatchupdate( 
                                                                                                                this.pathinvitationlist, 
                                                                                                                this.eventid,
                                                                                                                this.dragitem_invitationlistid,
                                                                                                                'delivery', 
                                                                                                                'TBC'
                                                                                                              );
                                                                        }
                                                                    }
                                                                )
                                                        }
                                                    )
                                                  }
                                              }
                                            )            

    }
  //*******************************************************
  onClickNewInviteList( event: any )
    {
      this.firestoredata.crudeventinvitationcard(  this.eventid )
    }
  //*******************************************************
  onItemClick_invitedelivery( event: any, selinviteid: string )  
    {

      // Update Invitation List - Delivery Point
      this.firestoredata.commitbatchupdate( 
                                            this.pathinvitationlist, 
                                            this.eventid,
                                            selinviteid,
                                            'delivery', 
                                            event.itemData
                                          );

      
      this.popupVisible = false;

    }
  //*******************************************************
  extract_invitationid( splittype: number, seltext: string, selsplit: string )
    {

      var retvalue: string;

      switch ( splittype )
        {
          case 10:
              {
                let invitationlistid = seltext.split(selsplit);
    
                retvalue =  invitationlistid[1].trim();
                break
              }

          case 20:
              {
                let invitationlistid = seltext.split(selsplit);

                retvalue = invitationlistid[1].trim();
                retvalue = retvalue.substring(0,4);
  
                break
              }

          case 30:
              {
                let invitationlistid = seltext.split(selsplit);
    
                retvalue =  invitationlistid[0].trim();
                break
              }
        
        }

      return retvalue;

    }
  //*******************************************************
  onDeliveryClicked(e: any) 
    {
      //console.log( e.id )
      //console.log( e.inviteename )
      this.build_invitee_deliveryoptions(  e.id , e.inviteename )
   }
  //*******************************************************
  btnmouseover( e: any )
   {
      if ( e.delivery == 'TBC')
        {
          this.deliveryhint = 'shshshshshshshs'
        }
      else
        {
          this.deliveryhint = e.delivery;
        }
   }
  //*******************************************************
}
